'use strict';


export default angular.module('fplTruescapeComApp.ngLoad', [])

    .directive('ngLoad', ['$parse', $parse => {
      return {
        restrict: 'A',
        link: (scope, elem, attrs) => {
          let fn = $parse(attrs.ngLoad);
          elem.on('load', event => {
            scope.$apply(() => {
              fn(scope, { $event: event });
            });
          });
        }
      };
    }])
    .name;



// WEBPACK FOOTER //
// ./client/components/directives/onLoad/onload.directive.js